import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";

export const RadioButtonsGroup = (props) => {
  const { id, data, onChange, value, color } = props;

  return (
    <FormControl component="fieldset" sx={{ mt: 0 }}>
      <RadioGroup
        aria-label={id}
        value={value ?? "all"}
        onChange={(event) => onChange(event.target.value)}
        name="radio-buttons-group"
        sx={{ pl: 1 }}
      >
        {data.map((radio, index) => (
          <FormControlLabel
            key={index}
            value={radio.value}
            control={<Radio color={color} size="small" sx={{ p: "5px" }} />}
            label={radio.label}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
